import { useCallback, useMemo } from "react";
import { useExtendedSearchInfiniteQuery } from "src/api/client/extended-search.api";
import { ISearchRequestParamsOmitCountry } from "src/components/pages/search/search.types";

export const useSearchGridResults = (searchParams: ISearchRequestParamsOmitCountry | null, enabled = true) => {
    const { data, isLoading, isError, isFetchingNextPage, hasNextPage, fetchNextPage } = useExtendedSearchInfiniteQuery(searchParams, {
        notifyOnChangeProps: ["data", "isLoading", "isError", "isFetchingNextPage", "hasNextPage"],
        enabled,
    });

    const onLoadMore = useCallback(() => {
        if (hasNextPage && !isFetchingNextPage) {
            fetchNextPage({ cancelRefetch: false });
        }
    }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

    const results = useMemo(() => (data ? data.pages.flatMap(page => page.results ?? []) : null), [data]);

    return {
        onLoadMore,
        results,
        isLoading,
        isFailed: isError,
        isFetchingNextPage,
        hasNextPage,
    };
};
